module.exports = __webpack_public_path__ + "fonts/NunitoSans_7pt-LightItalic.75d8032e.ttf";